<script>
import WishlistButton from '@phoenix/mixins/components/wishlist/WishlistButton';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxIcon,
  },

  mixins: [WishlistButton],

  props: {
    defaultInWishlistIcon: {
      type: String,
      default: 'heart-full-16',
    },
  },

  data() {
    return {
      defaultIcon: 'heart-16',
    };
  },
};
</script>

<template>
  <button
    class="btn btn--default btn--xs btn--icon-only btn--icon btn--transparent"
    :aria-label="ariaLabel"
    :data-cy="dataCy"
    :data-tracking="trackingDatalayer"
    @click.prevent="toggleProduct({ reference, showBanner })"
  >
    <span class="btn__icon">
      <phx-icon :key="icon" :icon="icon" />
    </span>
  </button>
</template>
